(function ($) {$(function(){
    const modal = $('#video-modal');
    const videoContainer = $('.video-modal-container');
    const worksList = $('.director-works-list li a');
    const videoCloseBtn = $('#video-close-btn');
    const videoHeader = $('.video-info-header');
    const videoTitle = $('#video-title');
    const videoSubtitle = $('#video-subtitle');
    const playerOptions = {
        iconUrl: window.wpkai_config.theme_dir_uri + '/resources/img/icons/player-icons.svg',
        settings: [],
        controls: [
            // 'play-large', // The large play button in the center
            // 'restart', // Restart playback
            // 'rewind', // Rewind by the seek time (default 10 seconds)
            'play', // Play/pause playback
            'progress', // The progress bar and scrubber for playback and buffering
            // 'fast-forward', // Fast forward by the seek time (default 10 seconds)
            // 'current-time', // The current time of playback
            // 'duration', // The full duration of the media
            'settings', // Settings menu
            'mute', // Toggle mute
            // 'volume', // Volume control
            // 'captions', // Toggle captions
            // 'pip', // Picture-in-picture (currently Safari only)
            // 'airplay', // Airplay (currently Safari only)
            // 'download', // Show a download button with a link to either the current source or a custom URL you specify in your options
            'fullscreen', // Toggle fullscreen
          ]
    };

    // const director = $('#director-name');
    // const body = $('body');
    // const modalCloseBtn = $('#director-modal-close');
    videoCloseBtn.on('click', function (e) {
        modal.removeClass('active');
        directorVideoPlayer.stop();
        const currURL= window.location.href;
        const beforeQueryString= currURL.split("?")[0];  
        window.history.replaceState({}, document.title, beforeQueryString);
    });

    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });
    if (params.v) {
        const $this = $('a[data-video-slug=' + params.v + ']');
        if ($this.length > 0) {
            playAVideo($this);
        }
    }
    function playAVideo($this) {
        videoTitle.html($this.data('video-title'))
        videoSubtitle.html($this.data('video-subtitle'))
        const videoElement = $(`<div id="video-player" data-plyr-provider="vimeo" data-plyr-embed-id="${$this.data('video-id')}"></div>`);
        modal.addClass('active');
        videoContainer.empty();
        videoContainer.append(videoElement);
        window.directorVideoPlayer = new Plyr('#video-player', playerOptions);
        directorVideoPlayer.on('ready', function () {
            directorVideoPlayer.play();
        })
        directorVideoPlayer.on('controlsshown', function () {
            videoHeader.addClass('active')
        })
        directorVideoPlayer.on('controlshidden', function () {
            videoHeader.removeClass('active')
        })
    }
    worksList.on('click', function (e) {
        const $this = $(this);
        if($this.attr('id') == 'open-director-gallery') return;
        e.preventDefault();
        const currURL= window.location.href;
        window.history.replaceState({}, document.title, currURL + '?v=' + $this.data('video-slug'));
        videoTitle.html($this.data('video-title'))
        videoSubtitle.html($this.data('video-subtitle'))
        const videoElement = $(`<div id="video-player" data-plyr-provider="vimeo" data-plyr-embed-id="${$this.data('video-id')}"></div>`);
        modal.addClass('active');
        videoContainer.empty();
        videoContainer.append(videoElement);
        window.directorVideoPlayer = new Plyr('#video-player', playerOptions);
        directorVideoPlayer.on('ready', function () {
            directorVideoPlayer.play();
        })
        directorVideoPlayer.on('controlsshown', function () {
            videoHeader.addClass('active')
        })
        directorVideoPlayer.on('controlshidden', function () {
            videoHeader.removeClass('active')
        })
        // body.addClass('director-info-modal-open');
    });
    // modalCloseBtn.on('click', function (e) {
    //     modal.removeClass('active');
    //     body.removeClass('director-info-modal-open');
    // });
});}(_jQ3));


// $html = wp_oembed_get($settings['vimeo_url']);
